import { render, staticRenderFns } from "./InspectorTeams.vue?vue&type=template&id=5d337f30&scoped=true&"
import script from "./InspectorTeams.vue?vue&type=script&lang=js&"
export * from "./InspectorTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d337f30",
  null
  
)

export default component.exports